/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/checkbox/custom-elements';

import { defineCustomElement as defineOsdsCheckbox } from '@ovhcloud/ods-stencil/components/checkbox/custom-elements/osds-checkbox.js';

export const OsdsCheckbox = /*@__PURE__*/createReactComponent<JSX.OsdsCheckbox, HTMLOsdsCheckboxElement>('osds-checkbox', undefined, undefined, defineOsdsCheckbox);
